import { render, staticRenderFns } from "./recent-studies.vue?vue&type=template&id=089d1633&scoped=true&"
import script from "./recent-studies.vue?vue&type=script&lang=ts&"
export * from "./recent-studies.vue?vue&type=script&lang=ts&"
import style0 from "./recent-studies.vue?vue&type=style&index=0&id=089d1633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d1633",
  null
  
)

export default component.exports